
/* Essentially Natural: MLV Recently Viewed product buying controls.
   Theme-staging enhancement. No edits to the app extension, storage or tracking.
   Product data and stock are requested from Shopify's Ajax product endpoint.
   Cards that cannot be confidently identified are left unchanged. */
(() => {
  "use strict";

  const APP_ID = "__17821312337aaab6eb";
  const root = document.querySelector(
    '#MainContent [id$="' + APP_ID + '"]'
  );

  if (!root || root.dataset.enRvInitialized) return;
  root.dataset.enRvInitialized = "true";

  const productCache = new Map();
  let scanQueued = false;
  let heightQueued = false;
  const PRODUCT_PATTERN = /\/products\/([^/?#]+)/;

  function productHandle(link) {
    try {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return null;

      const match = url.pathname.match(PRODUCT_PATTERN);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) {
      return null;
    }
  }

  function findProductCard(link, handle) {
    let node = link.parentElement;

    while (node && node !== root && root.contains(node)) {
      if (
        !node.matches("a,button,form") &&
        node.querySelector("img") &&
        /(?:R|ZAR)\s*[\d,.]+/i.test(node.textContent || "")
      ) {
        const handles = new Set(
          Array.from(node.querySelectorAll('a[href*="/products/"]'))
            .map(productHandle)
            .filter(Boolean)
        );

        if (handles.size === 1 && handles.has(handle)) return node;
        if (handles.size > 1) return null;
      }

      node = node.parentElement;
    }

    return null;
  }

  function fetchProduct(handle) {
    if (!productCache.has(handle)) {
      const rootPath =
        (window.Shopify &&
          Shopify.routes &&
          Shopify.routes.root) ||
        "/";

      const basePath = rootPath.endsWith("/")
        ? rootPath
        : rootPath + "/";

      const path =
        basePath +
        "products/" +
        encodeURIComponent(handle) +
        ".js";

      const request = fetch(path, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(async (response) => {
        if (!response.ok) {
          throw new Error("Shopify product unavailable");
        }

        return response.json();
      });

      productCache.set(handle, request);
    }

    return productCache.get(handle);
  }

  function errElement() {
    const el = document.createElement("p");
    el.className = "en-rv-error";
    el.setAttribute("role", "alert");
    el.hidden = true;
    return el;
  }

  function button(text) {
    const el = document.createElement("button");
    el.type = "button";
    el.className = "en-rv-buy";
    el.textContent = text;

    el.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    return el;
  }

  function formatMoney(cents) {
    const currency =
      (window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active) ||
      "ZAR";

    try {
      return new Intl.NumberFormat("en-ZA", {
        style: "currency",
        currency
      }).format(Number(cents) / 100);
    } catch (_) {
      return "";
    }
  }

  function getCartAddUrl() {
    const rootPath =
      (window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root) ||
      "/";

    const basePath = rootPath.endsWith("/")
      ? rootPath
      : rootPath + "/";

    // Use Shopify's AJAX endpoint to obtain a JSON response
    // rather than the redirecting /cart/add route.
    return basePath + "cart/add.js";
  }

  async function addToCart(
    variantId,
    quantity,
    trigger,
    error,
    modal
  ) {
    error.hidden = true;

    const oldLabel = trigger.textContent;
    trigger.disabled = true;
    trigger.textContent = "ADDING…";

    try {
      const form = new FormData();
      form.append("id", String(variantId));
      form.append("quantity", String(quantity));

      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      if (
        cart &&
        typeof cart.getSectionsToRender === "function"
      ) {
        const sections = cart
          .getSectionsToRender()
          .map((section) => section.id)
          .filter(Boolean);

        if (sections.length) {
          form.append("sections", sections.join(","));
          form.append("sections_url", window.location.pathname);
        }

        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(trigger);
        }
      }

      const addUrl = getCartAddUrl();

      const response = await fetch(addUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: form,
        credentials: "same-origin"
      });

      // Shopify may return valid JSON with a text/javascript
      // content type, so parse the response body itself rather
      // than requiring application/json in the response headers.
      const responseText = await response.text();
      let result;

      try {
        result = JSON.parse(responseText);
      } catch (_) {
        const contentType =
          response.headers.get("content-type") || "unknown";

        throw new Error(
          "The cart endpoint returned an unexpected response. " +
          "HTTP " + response.status +
          "; Content-Type: " + contentType +
          "; URL: " + addUrl +
          "; Response: " + responseText.slice(0, 180)
        );
      }

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          "Unable to add this product."
        );
      }

      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "en-recently-viewed",
          productVariantId: String(variantId),
          cartData: result
        });
      }

      if (modal && modal.open) {
        modal.close();
      }

      if (cart && typeof cart.renderContents === "function") {
        cart.renderContents(result);
      } else {
        // No compatible cart drawer is available.
        // Navigate to the cart only after a successful addition.
        const rootPath =
          (window.Shopify &&
            Shopify.routes &&
            Shopify.routes.root) ||
          "/";

        const basePath = rootPath.endsWith("/")
          ? rootPath
          : rootPath + "/";

        window.location.href = basePath + "cart";
      }
    } catch (exception) {
      console.error(
        "[Essentially Natural Recently Viewed] Add to cart failed:",
        exception
      );

      error.textContent =
        exception.message || "Unable to add this product.";

      error.hidden = false;
    } finally {
      trigger.disabled = false;
      trigger.textContent = oldLabel;
    }
  }

  function openOptions(product, parent) {
    const modal = document.createElement("dialog");
    modal.className = "en-rv-dialog";

    const headingRow = document.createElement("div");
    headingRow.className = "en-rv-dialog__top";

    const title = document.createElement("h2");
    title.className = "en-rv-dialog__title";
    title.textContent = product.title || "Choose product options";

    const close = button("×");
    close.className = "en-rv-dialog__close";
    close.setAttribute("aria-label", "Close product options");
    close.addEventListener("click", () => modal.close());

    headingRow.append(title, close);

    const label = document.createElement("label");
    label.className = "en-rv-dialog__label";
    label.textContent = "Select a size or option";

    const selector = document.createElement("select");
    selector.className = "en-rv-dialog__field";
    selector.setAttribute("aria-label", "Product size or option");

    for (const variant of product.variants) {
      const option = document.createElement("option");
      option.value = String(variant.id);

      option.textContent =
        (variant.public_title || variant.title || "Default") +
        (variant.available ? "" : " — Sold out");

      option.disabled = !variant.available;
      selector.append(option);
    }

    label.append(selector);

    const qtyLabel = document.createElement("label");
    qtyLabel.className = "en-rv-dialog__label";
    qtyLabel.textContent = "Quantity";

    const quantity = document.createElement("input");
    quantity.className = "en-rv-dialog__field";
    quantity.type = "number";
    quantity.inputMode = "numeric";
    quantity.value = "1";
    quantity.min = "1";
    quantity.step = "1";

    qtyLabel.append(quantity);

    const price = document.createElement("p");
    price.className = "en-rv-dialog__price";

    const submit = button("ADD TO CART");
    const error = errElement();

    const available = product.variants.find(
      (variant) => variant.available
    );

    if (available) {
      selector.value = String(available.id);
    }

    function selected() {
      return product.variants.find(
        (variant) => String(variant.id) === selector.value
      );
    }

    function update() {
      const variant = selected();
      const rule = (variant && variant.quantity_rule) || {};

      quantity.min = String(rule.min || 1);
      quantity.step = String(rule.increment || 1);

      if (rule.max) {
        quantity.max = String(rule.max);
      } else {
        quantity.removeAttribute("max");
      }

      quantity.value = quantity.min;
      price.textContent = variant
        ? formatMoney(variant.price)
        : "";

      submit.disabled = !variant || !variant.available;
    }

    selector.addEventListener("change", update);

    submit.addEventListener("click", (event) => {
      event.preventDefault();

      const variant = selected();
      if (!variant || !variant.available) return;

      const rule = variant.quantity_rule || {};
      const min = Number(rule.min) || 1;
      const increment = Number(rule.increment) || 1;
      const max = rule.max ? Number(rule.max) : Infinity;

      let requested = Number(quantity.value);

      if (!Number.isFinite(requested)) {
        requested = min;
      }

      requested = Math.max(min, requested);
      requested = min +
        Math.ceil((requested - min) / increment) * increment;

      if (Number.isFinite(max)) {
        requested = Math.min(
          requested,
          min + Math.floor((max - min) / increment) * increment
        );
      }

      if (requested < min || requested > max) {
        error.textContent = "Please enter a valid quantity.";
        error.hidden = false;
        return;
      }

      addToCart(
        variant.id,
        requested,
        submit,
        error,
        modal
      );
    });

    modal.addEventListener("click", (event) => {
      if (event.target === modal) modal.close();
    });

    modal.append(
      headingRow,
      label,
      qtyLabel,
      price,
      submit,
      error
    );

    document.body.append(modal);
    update();

    if (typeof modal.showModal === "function") {
      modal.showModal();
    } else {
      modal.setAttribute("open", "");
    }

    selector.focus();
  }

  function decorate(card, product) {
    if (
      !product ||
      !Array.isArray(product.variants) ||
      !product.variants.length ||
      card.querySelector(".en-rv-action")
    ) {
      return;
    }

    const actions = document.createElement("div");
    actions.className = "en-rv-action";

    const error = errElement();

    const liveVariants = product.variants.filter(
      (variant) => variant.available
    );

    const firstVariant =
      liveVariants[0] || product.variants[0];

    const qtyRule = firstVariant.quantity_rule || {};

    const needsOptions =
      product.variants.length !== 1 ||
      product.requires_selling_plan ||
      firstVariant.requires_selling_plan ||
      Number(qtyRule.min || 1) > 1 ||
      Number(qtyRule.increment || 1) > 1 ||
      Boolean(qtyRule.max);

    let buy;

    if (!liveVariants.length) {
      buy = button("SOLD OUT");
      buy.disabled = true;
    } else if (
      product.requires_selling_plan ||
      firstVariant.requires_selling_plan ||
      product.gift_card
    ) {
      // Do not bypass required subscriptions or gift-message fields.
      buy = button("VIEW PRODUCT");

      buy.addEventListener("click", () => {
        const link = card.querySelector('a[href*="/products/"]');
        if (link) window.location.href = link.href;
      });
    } else if (needsOptions) {
      buy = button("CHOOSE OPTIONS");

      buy.addEventListener("click", () => {
        openOptions(product, actions);
      });
    } else {
      buy = button("ADD TO CART");

      buy.addEventListener("click", () => {
        addToCart(
          firstVariant.id,
          1,
          buy,
          error,
          null
        );
      });
    }

    actions.append(buy, error);
    card.append(actions);

    queueEqualHeight();
  }

  function equalHeight() {
    const cards = Array.from(
      root.querySelectorAll(".en-rv-card")
    ).filter(
      (card) =>
        card.isConnected &&
        card.getBoundingClientRect().width > 0
    );

    for (const card of cards) {
      card.style.minHeight = "";
    }

    window.requestAnimationFrame(() => {
      const rows = new Map();

      for (const card of cards) {
        const top = Math.round(
          card.getBoundingClientRect().top / 6
        );

        const row = rows.get(top) || [];
        row.push(card);
        rows.set(top, row);
      }

      for (const row of rows.values()) {
        const height = Math.ceil(
          Math.max(
            ...row.map((card) =>
              card.getBoundingClientRect().height
            )
          )
        );

        if (Number.isFinite(height) && height > 0) {
          for (const card of row) {
            card.style.minHeight = height + "px";
          }
        }
      }
    });
  }

  function queueEqualHeight() {
    if (heightQueued) return;

    heightQueued = true;

    window.requestAnimationFrame(() => {
      heightQueued = false;
      equalHeight();
    });
  }

  function scan() {
    const links = Array.from(
      root.querySelectorAll('a[href*="/products/"]')
    );

    for (const link of links) {
      const handle = productHandle(link);
      if (!handle) continue;

      const card = findProductCard(link, handle);
      if (!card || card.dataset.enRvProcessed) continue;

      card.dataset.enRvProcessed = "pending";
      card.classList.add("en-rv-card");

      fetchProduct(handle)
        .then((product) => {
          if (!card.isConnected) return;

          decorate(card, product);
          card.dataset.enRvProcessed = "ready";
        })
        .catch((exception) => {
          console.warn(
            "[Essentially Natural Recently Viewed] " +
            "Product lookup failed:",
            handle,
            exception
          );

          // Never replace or disrupt a third-party product card
          // when product lookup fails.
          card.dataset.enRvProcessed = "failed";
        });

      queueEqualHeight();
    }
  }

  function scheduleScan() {
    if (scanQueued) return;

    scanQueued = true;

    window.requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  }

  const observer = new MutationObserver((changes) => {
    if (
      changes.some(
        (change) =>
          change.addedNodes.length ||
          change.removedNodes.length
      )
    ) {
      scheduleScan();
    }
  });

  observer.observe(root, {
    childList: true,
    subtree: true
  });

  scan();

  window.addEventListener(
    "resize",
    queueEqualHeight,
    { passive: true }
  );

  window.addEventListener(
    "load",
    queueEqualHeight,
    { once: true }
  );

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(queueEqualHeight);
  }

  window.setTimeout(queueEqualHeight, 1300);
})();
